import SpamRoute from './SpamRoute';

export default SpamRoute;
